interface Config {
  NODE_ENV: string | undefined;
  TRAVELHEARTS_API_URL: string | undefined;
  TRAVELHEARTS_IMAGES_URL: string | undefined;
  GOOGLE_CLIENT_ID: string | undefined;
  GOOGLE_MAPS_API_KEY: string | undefined;
  GOOGLE_MAP_ID: string | undefined;
  // ANOTHER_SECRET: string | undefined;
}

const config: Config = {
  NODE_ENV: process.env.NODE_ENV,
  TRAVELHEARTS_API_URL: process.env.REACT_APP_API_URL,
  TRAVELHEARTS_IMAGES_URL: process.env.REACT_APP_IMAGES_URL_BASE,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  GOOGLE_MAP_ID: process.env.REACT_APP_GOOGLE_MAP_ID
};

// Log the loaded environment variables
if (config.NODE_ENV === 'development') {
  console.log('Loaded environment variables:', config);
}

export default config;
